import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import UploadPhotos from './UploadPhotos';
import ViewGallery from './ViewGallery';

interface PhotoGalleryModuleProps {
  domain: string;
  onBack: () => void;
}

const PhotoGalleryModule: React.FC<PhotoGalleryModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '') {
      return location.pathname === '/dashboard/photo-gallery' || location.pathname === '/dashboard/photo-gallery/';
    }
    return location.pathname.includes(path);
  };

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-images me-2"></i>Photo Gallery
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${isActive('upload') ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/photo-gallery/upload')}
              >
                <i className="bi bi-cloud-upload me-2"></i>Upload Photos
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${isActive('') && !isActive('upload') ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/photo-gallery')}
              >
                <i className="bi bi-grid me-2"></i>View Gallery
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<ViewGallery domain={domain} />} />
          <Route path="upload" element={<UploadPhotos domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default PhotoGalleryModule;
